import { IStyle, IToggleStyles } from '@fluentui/react';
import { defaultSemanticColors, FontWeights } from '@h2oai/ui-kit';

export interface IRegisterFeatureSetAddSchemaStyles {
  root?: IStyle;
  messageBar?: IStyle;
  form?: IStyle;
  fields?: IStyle;
  fieldItem?: IStyle;
  subTitle?: IStyle;
  subTitleText?: IStyle;
  errorMessage?: IStyle;
  buttons?: IStyle;
  fileUploadContainer?: IStyle;
  fileUploadContainerHeader?: IStyle;
}

export interface IRegisterFeatureSetAddSchemaClassNames {
  root: string;
  messageBar: string;
  form: string;
  fields: string;
  fieldItem: string;
  subTitle: string;
  subTitleText: string;
  errorMessage: string;
  buttons: string;
  fileUploadContainer: string;
  fileUploadContainerHeader: string;
}

export const registerFeatureSetAddSchemaStylesDefault: Partial<IRegisterFeatureSetAddSchemaStyles> = {
  root: {
    flex: 1,
    paddingTop: 17,
    minHeight: 0,
  },
  messageBar: { position: 'absolute', zIndex: 1, right: '0px', top: '-81px' },
  form: { height: '100%', display: 'flex', flexDirection: 'column' },
  fields: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    minHeight: 0,
  },
  fieldItem: {
    display: 'flex',
    gap: 8,
    marginBottom: 16,
  },
  subTitle: {
    fontWeight: FontWeights.semiBold,
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px',
  },
  subTitleText: {
    lineHeight: '32px',
  },
  fileUploadContainer: {
    position: 'relative',
    marginTop: '16px',
  },
  fileUploadContainerHeader: {
    position: 'absolute',
    top: '20px',
    width: '100%',
    textAlign: 'center',
  },
  errorMessage: {
    color: defaultSemanticColors.inputErrorMessageText,
    maxHeight: '100px',
    overflow: 'auto',
  },
  buttons: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginTop: 16 },
};

export const toggleStylesRegisterFeatureSetAddSchema: Partial<IToggleStyles> = {
  root: {
    justifyContent: 'space-between',
    marginRight: '70%',
  },
};
